export const SET_STATS = 'SET_STATS';
export const REMOVE_STATS = 'REMOVE_STATS';
export const SET_IS_NEW_PAYMENT_SYSTEM = 'SET_IS_NEW_PAYMENT_SYSTEM';
export const SET_STATS_LOADING = 'SET_STATS_LOADING';


// WEBPACK FOOTER //
// ./src/store/modules/stats/mutations.js